export const useTermQueries = {};
